// src/components/admin/employees/wizard/Compensation.js
import React from 'react';
import BankDropdown from '../../../common/BankDropdown';

const Compensation = ({ formData, updateFormData, theme }) => {
    const handleChange = (e) => {
        const { name, value } = e.target;
        updateFormData({ [name]: value });
    };

    const inputClass = `w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 ${
        theme === 'dark'
            ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400'
            : 'bg-white border-gray-300 text-gray-900 placeholder-gray-400'
    }`;

    const labelClass = `block text-sm font-medium mb-2 ${
        theme === 'dark' ? 'text-gray-300' : 'text-gray-700'
    }`;

    const sectionTitleClass = `text-lg font-semibold mb-4 ${
        theme === 'dark' ? 'text-white' : 'text-gray-900'
    }`;

    return (
        <div className="space-y-6">
            <h3 className={sectionTitleClass}>Compensation Details</h3>

            <div className="grid grid-cols-2 gap-4">
                <div>
                    <label className={labelClass}>
                        Annual CTC<span className="text-red-500">*</span>
                    </label>
                    <input
                        type="number"
                        name="ctc"
                        value={formData.ctc}
                        onChange={handleChange}
                        placeholder="Enter Annual CTC"
                        required
                        className={inputClass}
                    />
                </div>
                <div>
                    <label className={labelClass}>
                        Currency<span className="text-red-500">*</span>
                    </label>
                    <select
                        name="currency"
                        value={formData.currency}
                        onChange={handleChange}
                        required
                        className={inputClass}
                    >
                        <option value="INR">INR - Indian Rupee</option>
                        <option value="USD">USD - US Dollar</option>
                        <option value="EUR">EUR - Euro</option>
                        <option value="GBP">GBP - British Pound</option>
                    </select>
                </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
                <div>
                    <label className={labelClass}>
                        Effective Date<span className="text-red-500">*</span>
                    </label>
                    <input
                        type="date"
                        name="effectiveDate"
                        value={formData.effectiveDate}
                        onChange={handleChange}
                        required
                        className={inputClass}
                    />
                </div>
                <div>
                    <label className={labelClass}>
                        Payroll Frequency<span className="text-red-500">*</span>
                    </label>
                    <select
                        name="payrollFrequency"
                        value={formData.payrollFrequency}
                        onChange={handleChange}
                        required
                        className={inputClass}
                    >
                        <option value="Monthly">Monthly</option>
                        <option value="Bi-Weekly">Bi-Weekly</option>
                        <option value="Weekly">Weekly</option>
                    </select>
                </div>
            </div>

            {/* Additional Compensation Fields */}
            {/* <h3 className={sectionTitleClass}>Salary Structure</h3>

            <div className="grid grid-cols-2 gap-4">
                <div>
                    <label className={labelClass}>Basic Salary</label>
                    <input
                        type="number"
                        name="basicSalary"
                        value={formData.basicSalary || ''}
                        onChange={handleChange}
                        placeholder="Basic Salary"
                        className={inputClass}
                    />
                </div>
                <div>
                    <label className={labelClass}>HRA</label>
                    <input
                        type="number"
                        name="hra"
                        value={formData.hra || ''}
                        onChange={handleChange}
                        placeholder="House Rent Allowance"
                        className={inputClass}
                    />
                </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
                <div>
                    <label className={labelClass}>Special Allowance</label>
                    <input
                        type="number"
                        name="specialAllowance"
                        value={formData.specialAllowance || ''}
                        onChange={handleChange}
                        placeholder="Special Allowance"
                        className={inputClass}
                    />
                </div>
                <div>
                    <label className={labelClass}>Variable Pay</label>
                    <input
                        type="number"
                        name="variablePay"
                        value={formData.variablePay || ''}
                        onChange={handleChange}
                        placeholder="Variable/Performance Pay"
                        className={inputClass}
                    />
                </div>
            </div> */}

            {/* Bank Details */}
            <h3 className={sectionTitleClass}>Bank Details</h3>

            <div className="grid grid-cols-2 gap-4">
                <div>
                    <BankDropdown
                        value={formData.bankName || ''}
                        onChange={(value) => updateFormData({ bankName: value })}
                        theme={theme}
                        placeholder="Select Bank Name"
                        className="w-full"
                    />
                </div>
                <div>
                    <label className={labelClass}>Account Number</label>
                    <input
                        type="text"
                        name="accountNumber"
                        value={formData.accountNumber || ''}
                        onChange={handleChange}
                        placeholder="Account Number"
                        className={inputClass}
                    />
                </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
                <div>
                    <label className={labelClass}>IFSC Code</label>
                    <input
                        type="text"
                        name="ifscCode"
                        value={formData.ifscCode || ''}
                        onChange={handleChange}
                        placeholder="IFSC Code"
                        className={inputClass}
                    />
                </div>
                <div>
                    <label className={labelClass}>Branch Name</label>
                    <input
                        type="text"
                        name="branchName"
                        value={formData.branchName || ''}
                        onChange={handleChange}
                        placeholder="Branch Name"
                        className={inputClass}
                    />
                </div>
            </div>

            {/* Tax Information */}
            <h3 className={sectionTitleClass}>Tax Information</h3>

            <div className="grid grid-cols-2 gap-4">
                <div>
                    <label className={labelClass}>PAN Number</label>
                    <input
                        type="text"
                        name="panNumber"
                        value={formData.panNumber || ''}
                        onChange={handleChange}
                        placeholder="PAN Number"
                        className={inputClass}
                    />
                </div>
                <div>
                    <label className={labelClass}>UAN Number</label>
                    <input
                        type="text"
                        name="uanNumber"
                        value={formData.uanNumber || ''}
                        onChange={handleChange}
                        placeholder="UAN Number"
                        className={inputClass}
                    />
                </div>
            </div>

            <div className={`p-4 rounded-lg ${
                theme === 'dark' ? 'bg-blue-900/20 border-blue-800' : 'bg-blue-50 border-blue-200'
            } border`}>
                <p className={`text-sm ${theme === 'dark' ? 'text-blue-300' : 'text-blue-800'}`}>
                    💡 <strong>Note:</strong> The compensation details can be updated later from the employee profile.
                    
                </p>
            </div>
        </div>
    );
};

export default Compensation;
